export const actionTypes = {
  REQUEST_START: 'TAPS.MOVEMENT_REPORT_DATA.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.MOVEMENT_REPORT_DATA.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.MOVEMENT_REPORT_DATA.REQUEST_FAILURE',
};

export function startRequest(data) {
  return {
    type: actionTypes.REQUEST_START,
    payload: data,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
